import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { APP_DICTIONARY } from '../root';
import type { SupplyPoint } from '@enmon/commons/lib/enmon';
import type { StrictOmit } from '@enmon/commons';

type TranslatedSupplyPointKeys = keyof StrictOmit<SupplyPoint, 'createdAt' | 'updatedAt' | '_id' | '__v' | 'detail'>;

export const SUPPLY_POINT_FIELDS_TRANSLATED = defineMessages<TranslatedSupplyPointKeys>({
  billingPeriod: APP_DICTIONARY.billingPeriod,
  code: { id: 'app.common.supplyPoint.fields.code' },
  contract: APP_DICTIONARY.contract,
  customer: { id: 'app.common.supplyPoint.fields.customer' },
  distributor: { id: 'app.common.supplyPoint.fields.distributor' },
  establishment: APP_DICTIONARY.establishment,
  name: APP_DICTIONARY.name,
  note: APP_DICTIONARY.note,
  registrationNumber: APP_DICTIONARY.registrationNumber,
  supplier: APP_DICTIONARY.supplier,
  commodity: APP_DICTIONARY.commodity,
  flowType: APP_DICTIONARY.flowType,
  category: APP_DICTIONARY.category,
  status: APP_DICTIONARY.status,
  location: APP_DICTIONARY.address,
  owner: APP_DICTIONARY.owner,
  activationDate: { id: 'app.common.supplyPoint.generalField.activationDate' },
});
